export const CULTURE_COOKIE_EXPIRY = '9999-12-30T22:00:00.000Z';
export const ORDER_FLASH_DRIVE_KEY = 'ssoShowOrderFlashDriveMessage';
export const PROJECT_CLOSED_KEY = 'ssoShowCloseSuccessMessage';
export const CLOSED_PROJECT_NAME_KEY = 'closedRoomName';
